import React from 'react';
import Badge from '../components/Badge';
import type { DocumentType } from '../graphql/generated';
import { gql } from '../graphql/generated';
import { Link } from '../utils/router/v3Bridge';
import topicPath from '../utils/url/topicPath';
import styles from './ContentMapColumnHeader.module.scss';
import TopicNameWithIcon from './TopicNameWithIcon';

const TOPIC_FRAGMENT = gql(`
  fragment ContentMapColumnHeader_topic on PublicTopicFields {
    id
    ...TopicNameWithIcon_topic
    ...topicPath_topic
  }
`);

interface ContentMapColumnHeaderProps {
  movedIn: boolean;
  name: string;
  link: boolean;
  topic: DocumentType<typeof TOPIC_FRAGMENT>;
}

const ContentMapColumnHeader = ({
  movedIn,
  name,
  link,
  topic,
}: ContentMapColumnHeaderProps) => {
  const children = (
    <div className={styles.name}>
      <TopicNameWithIcon topic={topic} name={name} truncate="single" />
      {movedIn && (
        <div className={styles.badgeContainer}>
          <Badge color="pink">Moved</Badge>
        </div>
      )}
    </div>
  );

  return link ? (
    <Link className={styles.container} to={topicPath(topic)}>
      {children}
    </Link>
  ) : (
    <div className={styles.container}>{children}</div>
  );
};

export default ContentMapColumnHeader;
